import { ETypeApp } from '@core/type';

// Used for build-time or when we are not in functional component
export const environmentApp = {
  typeApp: process.env.TYPE_APP as ETypeApp,
};
